import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { networkErrorToMessage } from './error'

export const useResultDispatch = () => {
  const globalDispatch = useDispatch()
  const { formatMessage } = useIntl()
  const dispatchError = (error, type) => {
    globalDispatch(
      MessageAlert.showError(networkErrorToMessage(formatMessage)(error, type)),
    )
  }
  const dispatchSuccess = (msg) => {
    globalDispatch(
      MessageAlert.showSuccess({
        message: msg,
      }),
    )
  }

  return { dispatchError, dispatchSuccess }
}
